import * as React from 'react'

export interface ConditionalWrapperProps {
  condition: boolean
  wrapper: (children: React.ReactNode) => React.ReactNode
  children?: React.ReactNode
}

export const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapperProps) =>
  (
    <>
      {condition ? wrapper(children) : children}
    </>
  )